import React from 'react';

import classNames from 'classnames';

import { Container, Link } from '@infoods/lifebase-ui';

import classes from './NgzPasswordResetComplete.module.scss';
import sendPasswordImg from '../../assets/image/send-password.png';
import { angularizeWithProviders } from '../../../shared/providers';
import { supportEmail, supportEmailHref } from '../../../shared/constants/supportEmail';

const NgzPasswordResetComplete = () => {
  return (
    <Container className={classes.container}>
      <div className={classes.paper}>
        <img src={sendPasswordImg} alt="send-password" className={classes.image} />
        <div className={classes.titleBox}>
          <h2 className={classes.title}>
            Check Your Latest Email For A Temporary Password.
          </h2>
          <h3 className={classNames(classes.title, classes.underline)}>
            Coaches And Entity Admins May Also Reset Passwords For Clients Manually.
          </h3>
          <p className={classes.description}>
            It has the new temporary password for your SWYMO account. Once you are logged
            in to your app/dashboard, you can reset your password in the Settings menu.
          </p>
        </div>
        <div className={classes.footerText}>
          <span className={classes.description}>
            If you have any questions, please contact
          </span>
          <Link href={supportEmailHref}>{supportEmail}</Link>
        </div>
      </div>
    </Container>
  );
};

angularizeWithProviders(NgzPasswordResetComplete, 'ngzPasswordResetComplete', {});

export { NgzPasswordResetComplete };
